import { AxiosError } from "axios";
import { enqueueSnackbar } from "notistack";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { USER_DATA_INFO_QUERY_KEY } from "src/shared/enums/useQueryKeys";
import { checkUserSession, loginCall, logoutCall } from "./gateway";
import { useNavigate } from "react-router-dom";
import React from "react";
import { LoginResponseDto } from "src/authentication/types";

export function useLoginQuery(
  setNeedToValidate: React.Dispatch<React.SetStateAction<any>>,
  setMailValidationToken: React.Dispatch<React.SetStateAction<any>>,
) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: loginCall,
    onSuccess: async () => {
      await queryClient.invalidateQueries(USER_DATA_INFO_QUERY_KEY);
      queryClient.removeQueries();
      setNeedToValidate(false);
      setMailValidationToken(undefined);
    },
    onError: (error: AxiosError<LoginResponseDto>) => {
      const message = error?.response?.data?.message;
      const needToValidate = error?.response?.data?.needToValidate;
      const mailValidationToken = error?.response?.data?.mailValidationToken;
      if (needToValidate) {
        setNeedToValidate(needToValidate);
        setMailValidationToken(mailValidationToken);
      }
      if (message) {
        enqueueSnackbar(message, {
          variant: "error",
        });
      }
    },
  });
}

export function useCheckSession() {
  const isError502Page = window.location.pathname === "/error502";
  return useQuery({
    queryFn: checkUserSession,
    queryKey: USER_DATA_INFO_QUERY_KEY,
    retry: isError502Page,
    retryDelay: 5000,
  });
}

export function useLogoutHandler() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: logoutCall,
    onSuccess: async () => {
      localStorage.removeItem("userInfo");
      await queryClient.invalidateQueries(USER_DATA_INFO_QUERY_KEY);
      navigate("/");
    },
  });
}
